import React, { useContext, useEffect } from 'react'
import { FlexView, SubHeader, Card, Table, Link, Spinner } from 'components/common'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { TubularContext } from 'stores/TubularStore'
import moment from 'moment'
import { formatIppnFull } from 'utils/format'
import { useHistory, useParams } from 'react-router-dom'
import Collapse from 'components/sot/Collapse'
import { RiClipboardLine } from 'react-icons/ri'
import { UserContext } from "../stores/UserStore"

const Subtitle = styled.h3`
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 10px;
    text-align: justify;
    color: #777777;
    margin: 16px 0;
`

const SpanTitle = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  display: flex;
  align-items: center;
  text-align: center;
  margin: 0px 0px 8px;
  color: #303030;
`

const FlexViewMaterialTable = styled(FlexView)`
  max-width: 50ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
const Sot = () => {
  const { registryLogOld, registryLog } = useContext(UserContext)
  const history = useHistory()
  const { getSotSearchData, setSotId, sotResult, isLoading } = useContext(TubularContext)
  const { t } = useTranslation()
  const { sotId } = useParams()

  const columns = [
    {
      Header: t('tlh.sot.ippn'),
      accessor: (row) => {
        if (row.ippn.indexOf("Luva") > -1) {
          return formatIppnFull(row.ippn)
        } else {
          return <>
            <Link onClick={() => goTo(row.ippn)}> {formatIppnFull(row.ippn)}</Link>
          </>
        }
      },
      id: 'ippn',
    },
    {
      Header: t('tlh.sot.status'),
      accessor: 'dscStatus',
      id: 'dscStatus',
    },
    {
      Header: t('tlh.sot.incomingNm'),
      accessor: 'incomingNm',
      id: 'incomingNm',
    },
    {
      Header: t('tlh.sot.incomingNmdescription'),
      accessor: row => <FlexViewMaterialTable>{row.dscIncomingNm}</FlexViewMaterialTable>,
      id: 'dscIncomingNm',
    },
    {
      Header: t('tlh.sot.incomingInvoice'),
      accessor: 'incomingInvoice',
      id: 'incomingInvoice',
    },
    {
      Header: t('tlh.sot.incomingInvoiceDate'),
      accessor: row => row.incomingInvoiceDate ? moment(row.incomingInvoiceDate).format('DD/MM/YYYY') : '',
      id: 'incomingInvoiceDate',
    },
    {
      Header: t('tlh.sot.outgoingNm'),
      accessor: 'outgoingNm',
      id: 'outgoingNm',
    },
    {
      Header: t('tlh.sot.outgoingNmdescription'),
      accessor: row => <FlexViewMaterialTable>{row.dscOutgoingNm}</FlexViewMaterialTable>,
      id: 'dscOutgoingNm',
    },
    {
      Header: t('tlh.sot.outgoingInvoice'),
      accessor: 'outgoingInvoice',
      id: 'outgoingInvoice',
    },
    {
      Header: t('tlh.sot.outgoingInvoiceDate'),
      accessor: row => row.outgoingInvoiceDate ? moment(row.outgoingInvoiceDate).format('DD/MM/YYYY') : '',
      id: 'outgoingInvoiceDate',
    },
    {
      Header: t('tlh.sot.warehouse'),
      accessor: 'warehouse',
      id: 'warehouse',
    }
  ]

  const goTo = (value) => {
    registryLogOld('got_to_ippn', '/tlh/sot')
    registryLog('sot', 'navigation', 'got_to_ippn')
    history.push("/ippn/" + value)
  }

  useEffect(() => {
    registryLogOld('client_in', '/tlh/sot')
    registryLog('sot', 'navigation', 'client_in')

    const handleJobIdParam = (id) => {
      if (id) {
        setSotId(id)
        registryLogOld('getSotSearchData', '/tlh/sot')
        registryLog('sot', 'navigation', 'get_sot_search_data')
        getSotSearchData([id, '', '', ''])
      }
    }
    handleJobIdParam(sotId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  console.log(sotResult.total)
  const content = <>
    {
      isLoading ?
        <FlexView flex="1" width="100%" height="100%" alignItems="center" padding="50px" fontSize="big" fontWeight="bold" color="gray" backgroundColor="transparent">
          <Spinner style={{ marginTop: "22%" }} />
        </FlexView>
        :
        <FlexView
          flexDirection="column"
          alignSelf="stretch"
          width='100%'>
          {
            sotResult.total > 0 ?
              <>
                <SubHeader title={t('tlh.sot.title')} value={'SOT ' + sotResult.detailsData.sot} />
                <Card alignSelf="center" borderRadius="16px" width='2300px' style={{ maxWidth: "90%" }} backgroundColor="#f4f4f4">
                  <SpanTitle>
                    <RiClipboardLine style={{ margin: '0px 8px 0px 4px', color: '#777777' }} />
                    <Subtitle>{t('tlh.sot.itemTitle')}</Subtitle>
                  </SpanTitle>

                  {sotResult.detailsData.description.map(({ item, nm, obs, report, pieces }, i) => (
                    <Collapse isExpand={false} item={item} nm={nm} qty={pieces} report={report} index={i} width='100%'>
                      {obs}
                    </Collapse>
                  ))}

                  <SpanTitle style={{ marginTop: '20px' }}>
                    <RiClipboardLine style={{ margin: '0px 8px 0px 4px', color: '#777777' }} />
                    <Subtitle>{t('tlh.sot.tableTitle')}</Subtitle>
                  </SpanTitle>

                  <Card width="95%" borderRadius="16px" alignSelf="center">
                    <Table width='100%' columns={columns} data={sotResult.table} sortable elevation="none" paginated style={{ whiteSpace: 'nowrap' }} />
                  </Card>
                </Card>
              </>
              :
              <Card alignSelf="center" borderRadius="16px" width='2300px' style={{ maxWidth: "90%" }} backgroundColor="#f4f4f4">
                <SubHeader value={t('tlh.noData')} />
              </Card>
          }
        </FlexView>
    }
  </>
  return content
}

export default Sot
